import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../contexts/LanguageContext';

const Services: React.FC = () => {
  const { t } = useLanguage();

  const entries = [
    {
      role: t('services.psychologyConsultant'),
      place: 'Vitruvius',
      description: t('services.psychologyConsultantDescription'),
      current: true,
    },
    {
      role: t('services.clinicalNeuropsychologist'),
      place: t('services.clinicalNeuropsychologistWorkplace'),
      description: t('services.clinicalNeuropsychologistDescription'),
    },
    {
      role: t('services.schoolPsychologist'),
      place: t('services.schoolPsychologistWorkplace'),
      description: t('services.schoolPsychologistDescription'),
    },
    {
      role: t('services.clinicalPsychologist'),
      place: t('services.clinicalPsychologistWorkplace'),
      description: t('services.clinicalPsychologistDescription'),
    },
    {
      role: t('services.psychologyIntern'),
      place: t('services.psychologyInternWorkplace'),
      description: t('services.psychologyInternDescription'),
    },
  ];

  return (
    <section id="services" className="section">
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={7}>
            <p className="kicker">{t('nav.experience')}</p>
            <h2 className="section-title">{t('services.title')}</h2>
            <p className="text-muted mb-0">{t('services.subtitle')}</p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={8} xl={7}>
            <ul className="timeline">
              {entries.map((entry) => (
                <li key={entry.role} className="timeline-item">
                  <h3 className="timeline-role">
                    {entry.role}
                    {entry.current && (
                      <span className="timeline-badge">{t('services.current')}</span>
                    )}
                  </h3>
                  <p className="timeline-place">{entry.place}</p>
                  <p className="timeline-desc">{entry.description}</p>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Services;
